import { useState } from 'react';
import { useFetch } from '../../hooks/useFetch';
import { servicesApi } from '../../api/servicesApi';
import { Button } from '../../components/ui/Button';

const VIDE = {
  nom: '',
  univers: 'particulier',
  parent_id: '',
  ordre: 0,
};

export function ServiceCategoriesManager() {
  const { data: categories, loading, refetch } = useFetch(() => servicesApi.categories(), []);
  const [edition, setEdition] = useState(null);
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  function ouvrirCreation() {
    setEdition({ ...VIDE });
    setErrors({});
  }

  function ouvrirEdition(categorie) {
    setEdition({ ...VIDE, ...categorie });
    setErrors({});
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setSubmitting(true);
    setErrors({});

    try {
      const payload = {
        ...edition,
        parent_id: edition.parent_id || null,
      };
      if (edition.id) {
        await servicesApi.updateCategory(edition.id, payload);
      } else {
        await servicesApi.createCategory(payload);
      }
      setEdition(null);
      refetch();
    } catch (err) {
      setErrors(err.errors || { _global: err.message });
    } finally {
      setSubmitting(false);
    }
  }

  async function handleDelete(id) {
    if (!window.confirm('Supprimer cette catégorie ? Les services associés resteront mais sans catégorie valide.')) return;
    await servicesApi.removeCategory(id);
    refetch();
  }

  if (loading) return <p>Chargement...</p>;

  return (
    <section>
      <div className="admin-toolbar">
        <h1>Catégories de services</h1>
        {!edition && <Button onClick={ouvrirCreation}>+ Nouvelle catégorie</Button>}
      </div>

      {edition && (
        <form className="admin-form" onSubmit={handleSubmit}>
          <div className="admin-form__field">
            <label>Nom</label>
            <input value={edition.nom} onChange={(e) => setEdition({ ...edition, nom: e.target.value })} required />
            {errors.nom && <span className="admin-form__error">{errors.nom}</span>}
          </div>

          <div className="admin-form__field">
            <label>Univers</label>
            <select value={edition.univers} onChange={(e) => setEdition({ ...edition, univers: e.target.value })}>
              <option value="particulier">Particulier</option>
              <option value="professionnel">Professionnel</option>
            </select>
            {errors.univers && <span className="admin-form__error">{errors.univers}</span>}
          </div>

          <div className="admin-form__field">
            <label>Catégorie parente (optionnel)</label>
            <select
              value={edition.parent_id || ''}
              onChange={(e) => setEdition({ ...edition, parent_id: e.target.value })}
            >
              <option value="">Aucune</option>
              {categories
                ?.filter((cat) => cat.id !== edition.id)
                .map((cat) => (
                  <option key={cat.id} value={cat.id}>
                    {cat.nom} ({cat.univers})
                  </option>
                ))}
            </select>
          </div>

          <div className="admin-form__field">
            <label>Ordre d'affichage</label>
            <input
              type="number"
              value={edition.ordre}
              onChange={(e) => setEdition({ ...edition, ordre: e.target.value })}
            />
          </div>

          {errors._global && <p className="admin-form__error">{errors._global}</p>}

          <div className="admin-form__actions">
            <Button type="submit" disabled={submitting}>
              {edition.id ? 'Enregistrer' : 'Créer'}
            </Button>
            <Button type="button" variant="secondary" onClick={() => setEdition(null)}>
              Annuler
            </Button>
          </div>
        </form>
      )}

      <table className="admin-table">
        <thead>
          <tr>
            <th>Nom</th>
            <th>Univers</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {categories?.map((cat) => (
            <tr key={cat.id}>
              <td>{cat.nom}</td>
              <td>{cat.univers}</td>
              <td className="admin-table__actions">
                <button onClick={() => ouvrirEdition(cat)}>Modifier</button>
                <button onClick={() => handleDelete(cat.id)}>Supprimer</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {!categories?.length && <p>Aucune catégorie pour le moment — créez-en une pour pouvoir ajouter des services.</p>}
    </section>
  );
}
